import { Box, Loader, Flex } from '@mantine/core';
import { LoginForm } from '@shared/ui';
import { RecoverPassword } from '@features/auth';
import { useShowMe, useAuth } from '@entities/auth';

export const RecoverPasswordPage = () => {
  const { isLoading: isLoadingShowMe } = useShowMe();
  const { isAuthenticated } = useAuth();

  if (isLoadingShowMe || isAuthenticated) {
    return (
      <Flex justify='center' w='100%'>
        <Loader size='lg' />
      </Flex>
    );
  }

  return (
    <LoginForm
      title='Забыли пароль?'
      description='На указанный в форме email мы отправим ссылку для восстановления пароля'
    >
      <Box pt='2rem'>
        <RecoverPassword />
      </Box>
    </LoginForm>
  );
};
